import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SubscriptionPrivateRoutes = ({ children }) => {
	const subscription = useSelector((state) => state.userInfo?.userInfo?.data?.subscription);

	if (subscription?.is_active && subscription?.status === 'active') {
		return (
			<Navigate
				to="/payment-success"
				replace
			/>
		);
	}

	return children;
};

export default SubscriptionPrivateRoutes;
